import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import Right from "./Right";
import { server } from "../../server";
import { getUserIdFromToken } from "../../utils/auth";

function RequestedPhoto() {
  const navigate = useNavigate();
  const [visitedProfiles, setRequestedPhoto] = useState([]);
  const [loading, setLoading] = useState(true);
  const getAge = (dob) => Math.floor((Date.now() - dob) / 3.15576e10);

  useEffect(() => {
    const fetchRequestedPhoto = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const userId = await getUserIdFromToken();

        const response = await fetch(
          `${server}/photoRequest/GetPhotoRequestsByUserId?userId=${userId}`,
          {
            headers: { Authorization: token },
          }
        );

        const data = await response.json();
        const sortedVisits = (data || []).sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        setRequestedPhoto(sortedVisits);
      } catch (err) {
        console.error("Failed to fetch visited profiles:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchRequestedPhoto();
  }, []);

  return (
    <>
      <Header />

      <section>
        <div className="container pt-3">
          <div className="row g-3">
            <div className="col-lg-8 col-12 mb-5">
              <div className="d-flex align-items-center mb-3">
                <Link
                  onClick={() => navigate(-1)}
                  className="icon-shape me-3 icon-lg bg-light-red rounded-circle"
                >
                  <i className="bi bi-chevron-left fs-3 text-primary"></i>
                </Link>
                <div>
                  <h3 className="fw-medium ls-sm text-dark lh-1 fs-4 m-0">
                    Requested Photo
                  </h3>
                  <p className="lh-sm fw-normal m-0">
                    Keep track of the profiles you’ve requested photos.
                  </p>
                </div>
              </div>
              <div className="bg-white rounded-4">
                <div className="p-4">
                  {loading ? (
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <div
                        class="spinner-border text-red-primary my-4"
                        role="status"
                      ></div>
                    </div>
                  ) : visitedProfiles.length === 0 ? (
                    <div className="text-center">
                      <img
                        src="/assets/images/no-data-2.png"
                        width="130"
                        alt="No data"
                      />
                      <p className="mt-2">Not Requested Photo Yet</p>
                    </div>
                  ) : (
                    visitedProfiles.map((item) => (
                      <Link
                        key={item._id}
                        to="/profile"
                        state={{ profileId: item.requestedProfileId }}
                        className="d-flex justify-content-between align-items-center mb-2"
                      >
                        <div className="d-flex align-items-center">
                          <img
                            src={
                              item?.profileDetails?.images?.[0]?.docUrl ||
                              "/assets/images/default-profile.jpg"
                            }
                            className="object-fit-cover rounded-circle"
                            width="50"
                            height="50"
                            alt="Profile"
                          />
                          <div className="ms-3">
                            <h4 className="fw-normal ls-sm fw-medium text-dark lh-1 mb-1">
                              {item?.profileDetails?.name},{" "}
                              {getAge(item?.profileDetails?.profile?.dob)}
                            </h4>
                            <p className="d-flex align-items-center m-0 lh-1 text-secondary">
                              {item?.profileDetails?.profile?.profession ||
                                "No Profession"}{" "}
                              <i className="bi bi-circle-fill fs-dot mx-2"></i>
                              {item?.profileDetails?.profile?.annualIncome ||
                                "No Income"}
                            </p>
                            <p className="d-flex align-items-center m-0 lh-1">
                              {item?.profileDetails?.profile?.state},{" "}
                              {item?.profileDetails?.profile?.city}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="icon-shape icon-sm bg-light rounded-circle">
                            <i className="bi bi-chevron-right fs-4 text-dark"></i>
                          </div>
                        </div>
                      </Link>
                    ))
                  )}
                </div>
              </div>
            </div>

            <Right />
          </div>
        </div>
      </section>
    </>
  );
}

export default RequestedPhoto;
